module.exports = __webpack_public_path__ + "img/forward.47edad55.svg";